export const CAR_PROTECTION_ADDON_TYPE = 'car_protection';
export const TYPE_TO_DISPLAY_MAPPING = {
    [CAR_PROTECTION_ADDON_TYPE]: 'Parked Car Protection',
};
